const features = [
  {
    icon: 'ri-flashlight-fill',
    title: '极速更新 · 快人一步',
    desc: '7×24小时全天候运营，专业编辑团队实时追踪热点。瓜熟蒂落的瞬间，我们已经在推送上等你。平均发布速度领先同行30分钟以上，让你永远是朋友圈里最先知道的那个人。',
  },
  {
    icon: 'ri-shield-check-fill',
    title: '三重审核 · 真实可靠',
    desc: '平台建立严格的三级内容审核机制：AI初筛、编辑复核、主编终审。每条爆料必须标注信息来源和可信度评级，坚决抵制谣言和虚假信息。真实是我们的底线。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端覆盖 · 随时吃瓜',
    desc: '网页版、iOS APP、Android APP三端全覆盖，数据实时同步。无论你在电脑前还是地铁上，打开每日爆料就能接上最新的瓜。APP支持离线缓存和个性化推荐。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-2">平台优势</h2>
        <p className="text-foreground-500 text-sm text-center mb-8">为什么800万用户选择每日爆料？</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-200 text-center"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto mb-4">
                <i className={`${feat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}